import type { PropType } from 'virtual-vue';
import type { PopupPosition } from './popup';

export const props = {
  visible: {
    type: Boolean,
    default: false,
  },
  position: {
    type: String as PropType<PopupPosition>,
    default: 'center',
  },
  overlayClass: String,
  closeOnClickOverlay: {
    type: Boolean,
    default: true,
  },
  duration: {
    type: [Number, String],
    default: 0.3,
  },
  lockScroll: {
    type: Boolean,
    default: true,
  },
  zIndex: Number,
  destroyOnClose: {
    type: Boolean,
    default: false,
  },
  overlay: {
    type: Boolean,
    default: true,
  },
  teleport: {
    type: String,
    default: 'body',
  },
};
